export default "__VITE_ASSET__sQI8QYF4__"